export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export type KindnessCategory = 'Patient' | 'Provider' | 'Staff' | 'Family';

export interface KindnessStory {
  id: string;
  author: string;
  role: KindnessCategory;
  setting: string;
  content: string;
  date: string;
  location: string;
}

export const sampleStories: KindnessStory[] = [
  {
    id: '1',
    author: 'Sarah M.',
    role: 'Patient',
    setting: 'St. Jude Medical Center',
    content: 'The oncology nurse stayed 20 minutes past her shift just to hold my hand while I received my results. She didn\'t have to, but she saw I was alone.',
    date: '2026-02-15',
    location: 'San Francisco, CA',
  },
  {
    id: '2',
    author: 'David K.',
    role: 'Staff',
    setting: 'City General Hospital',
    content: 'I saw a surgeon stop in the hallway to help an elderly visitor find the exit. He didn\'t just point; he walked with her the entire way to the parking garage.',
    date: '2026-02-10',
    location: 'Chicago, IL',
  },
  {
    id: '3',
    author: 'Elena R.',
    role: 'Provider',
    setting: 'Riverside Pediatrics',
    content: 'A young patient brought a handmade card for the cleaning crew. Seeing the janitorial staff recognized as heroes brought tears to everyone\'s eyes.',
    date: '2026-01-28',
    location: 'Austin, TX',
  },
  {
    id: '4',
    author: 'Marcus J.',
    role: 'Family',
    setting: 'Hope Hospice',
    content: 'The receptionist remembered my father\'s favorite tea and had it ready every morning I came to visit him during his final weeks. That small gesture meant the world.',
    date: '2026-02-20',
    location: 'Portland, OR',
  },
];

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function scrollToSection(id: string) {
  const element = document.getElementById(id);
  if (element) {
    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}